import React from 'react';

const PencilIcon = () => (
  <div>
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.66126 12C0.56988 11.9998 0.479533 11.9807 0.395963 11.9437C0.312394 11.9067 0.237431 11.8528 0.17584 11.7853C0.113137 11.7183 0.0652895 11.6389 0.0354367 11.5522C0.00558386 11.4655 -0.00560026 11.3734 0.00261752 11.2821L0.163985 9.50769L7.6185 2.05581L9.94812 4.38477L2.49558 11.836L0.721196 11.9974C0.701271 11.9992 0.681269 12.0001 0.66126 12ZM10.4131 3.91911L8.08416 1.59015L9.48114 0.193171C9.54231 0.131933 9.61495 0.083352 9.69491 0.0502063C9.77487 0.0170606 9.86057 0 9.94713 0C10.0337 0 10.1194 0.0170606 10.1993 0.0502063C10.2793 0.083352 10.3519 0.131933 10.4131 0.193171L11.8101 1.59015C11.8713 1.65132 11.9199 1.72396 11.9531 1.80392C11.9862 1.88388 12.0033 1.96959 12.0033 2.05614C12.0033 2.1427 11.9862 2.2284 11.9531 2.30836C11.9199 2.38832 11.8713 2.46096 11.8101 2.52213L10.4138 3.91845L10.4131 3.91911Z"
        fill="white"
      />
    </svg>
  </div>
);

export default PencilIcon;
